import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { ICoverageApiDependencySegment } from '@cbridge-packages/api-coverage';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { CoverageServerAction } from '../coverageServer.action';

type IDependencies = ICoverageApiDependencySegment;

export const removeCoverageServerEpic: IEpic<{}, IDependencies> = (action$, _, { coverageApi }) => action$.pipe(
  isTypeOfAndGetPayload(CoverageServerAction.remove.started),
  mergeMap((params) => coverageApi.deleteCoverageServer(params.serverId).pipe(
    mergeMap(() => [CoverageServerAction.remove.done({ params })]),
    catchApiError((error) => [
      CoverageServerAction.remove.failed({ params, error }),
      createApiErrorNotification(error),
    ]),
  )),
);
